import { Link } from "react-router-dom";

// Material
import { Divider, List, ListItemText, ListItemButton, Stack, ListItem, Collapse, Fade } from "@mui/material";
import ListItemIcon from "@mui/material/ListItemIcon";

import { HeaderMenuItemProps, HeaderMenuSection } from "../interfaces";

interface ISubMenuItemsProps extends HeaderMenuItemProps {
	showDescription: boolean;
}

function SubMenuItems(props: Readonly<ISubMenuItemsProps>) {
	return (
		<ListItem className="!px-0">
			<ListItemButton
				disabled={!props.hasAccess}
				className="list-item-arrow !px-0 !bg-transparent"
				component={Link}
				to={`${props.url}`}
			>
				<ListItemIcon className="!mx-[5px] !my-0">
					<img className="w-11 h-5 mx-auto" src={props.icon} alt="" />
				</ListItemIcon>

				<ListItemText
					className="relative text-default !m-0"
					primary={props.label}
					primaryTypographyProps={{ className: "!font-montserrat !text-[14px]/[20px] !font-medium max-w-[200px]" }}
					secondaryTypographyProps={{
						component: "span",
					}}
					secondary={
						<>
							<Fade
								in={props.showDescription}
								timeout={400}
								className="absolute top-5 left-0 !text-neutral-gray !font-sans !text-[14px]/[20px] text-nowrap max-w-full !m-0"
							>
								<div>{props.description}</div>
							</Fade>
							<Collapse timeout={400} in={props.showDescription}>
								<div className="h-5"></div>
							</Collapse>
						</>
					}
				/>
			</ListItemButton>
		</ListItem>
	);
}

function renderOptions(menuItems: HeaderMenuItemProps[], showDescription = false) {
	return (
		<List className="!p-0 !m-0">
			{menuItems.map((menuItem, index) => (
				<Stack key={`render_option_${menuItem.label}_${index}`}>
					<SubMenuItems {...menuItem} showDescription={showDescription} />
				</Stack>
			))}
		</List>
	);
}

interface SubMenuProps {
	menuSection: HeaderMenuSection;
	showDescription: boolean;
}

function SubMenu(props: Readonly<SubMenuProps>) {
	const { menuSection, showDescription } = props;

	return (
		<Stack className="flex grow flex-col justify-items-start">
			{menuSection.menuItemGroups.map((department, index) => (
				<Stack key={`department-pay-plans-${department.id}`}>
					{index > 0 && <Divider className="!my-1" />}
					<Stack>
						<Stack>{renderOptions(department.menuItems, showDescription)}</Stack>
					</Stack>
				</Stack>
			))}
		</Stack>
	);
}

export default SubMenu;
